<template>
  <div>
    <template>
      <b-modal
        v-model="modalOk"
        :active="modalOk"
        :width="900"
        :on-cancel="
          () => {
            modalOk = false
          }
        "
      >
        <div class="card">
          <div class="card-content">
            <header class="modal-card-head">
              <p class="modal-card-title">{{ title }}</p>
              <button class="delete" type="button" @click="closing()"></button>
            </header>

            <template>
              <div>
                <section class="container section page-header section is-main-section">
                  <form @submit.prevent="saveSettings">
                    <div>
                      <card-component>
                        <div class="columns">
                          <div class="column">
                            <label class="label">isActive</label>
                            <div class="field">
                              <b-switch v-model="isActive">
                                {{ isActive ? isActive : false }}
                              </b-switch>
                            </div>
                          </div>
                          <div class="column">
                            <label class="label">is Approval Needed</label>
                            <div class="field">
                              <b-switch v-model="isApprovalNeeded">
                                {{ isApprovalNeeded ? isApprovalNeeded : false }}
                              </b-switch>
                            </div>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Concession Type
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control select is-fullwidth">
                                <select :disabled="someParamsVisible" required v-model="concessionTypeVariable">
                                  <option value="">---Select---</option>
                                  <option v-for="(conty, index) in concessionType" :value="conty" :key="index.id">{{ conty }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Concession Name
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input required class="input" placeholder="Concession Name" type="text" v-model.trim="concessionName" />
                              </div>
                            </div>
                          </div>
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Automatic/Manual/Fixed
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control select is-fullwidth">
                                <select required v-model="concessionOrderTypeVariable">
                                  <option value="">---Select---</option>
                                  <option v-for="(conty, index) in concessionOrderType" :value="conty" :key="index.id">{{ conty }}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <drop-down type="forCurrentYear" :disabled="someParamsVisible"></drop-down>
                          </div>
                          <!-- <div class="column">
                            <div class="field">
                              <label class="label">
                                Concession Order
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control select is-fullwidth">
                                <select required v-model="concessionOrderVariable">
                                  <option value="">---Select---</option>
                                  <option v-for="(conty, index) in concessionOrder" :value="conty" :key="index.id">{{ conty }}</option>
                                </select>
                              </div>
                            </div>
                          </div> -->
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                {{ concessionOrderTypeVariable === 'Automatic(on percentage basis)' ? 'Concession(%)' : 'Amount(INR)' }}
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control  is-fullwidth">
                                <input
                                  required
                                  @keyup="exceptEValidation"
                                  step="any"
                                  :placeholder="concessionOrderTypeVariable === 'Automatic(on percentage basis)' ? 'Concession(%)' : 'Amount(INR)'"
                                  class="input"
                                  type="number"
                                  v-model="amount"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div class="field">
                              <label class="label">
                                Fee Type
                                <span class="has-text-danger">*</span>
                              </label>
                              <div class="control is-fullwidth">
                                <div>
                                  <multiselect
                                    class="overflowmultiselect1"
                                    :disabled="someParamsVisible"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    :preselect-first="false"
                                    :multiple="true"
                                    :options="feeType.map(type => type.id)"
                                    v-model="feeTypeVariable"
                                    :custom-label="opt => feeType.find(x => x.id == opt).name"
                                    ><template slot="tags" slot-scope="{ values }"
                                      ><span class="multiselect__single" v-if="values.length">
                                        {{ values.name }}
                                      </span></template
                                    >
                                  </multiselect>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="column " v-if="concessionTypeVariable !== royaltyConcession">
                            <div class="field">
                              <label class="label">
                                Select Franchisee

                                <span class="has-text-danger">*</span>
                                <span> <b-checkbox :disabled="someParamsVisible" v-model="flag" @input="allFranchisee"> All</b-checkbox></span>
                              </label>

                              <div class="control select is-fullwidth">
                                <multiselect
                                  track-by="id"
                                  label="companyName"
                                  :disabled="someParamsVisible"
                                  class="overflowmultiselect1"
                                  :close-on-select="false"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  :preselect-first="false"
                                  :multiple="true"
                                  :options="franchiseeArr"
                                  :optionHeight="10"
                                  v-model="franchiseeIDs"
                                  @remove="onTouch"
                                >
                                  >
                                  <template slot="selection" slot-scope="{ values, isOpen }"
                                    ><span class="multiselect__single" v-if="values.role &amp;&amp; !isOpen">{{ values.companyName }} </span></template
                                  >
                                </multiselect>
                              </div>
                            </div>
                          </div>
                        </div>

                        <footer class="column has-text-left" style="padding-bottom:100px">
                          <button class="button is-success" type="submit">Save</button>
                        </footer>
                      </card-component>
                    </div>
                  </form>
                </section>
              </div>
            </template>
          </div>
        </div>
      </b-modal>
    </template>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Concession List</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link :to="{ name: 'settingView' }" class="button is-small is-link">Back to Settings</router-link>
          </div>
          <div class="level-item">
            <button class="button is-info is-small btnicon" @click="ModalOpen()" title="Add">
              Create Concession
            </button>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column ">
          <drop-down type="forAcadmicYear" @change="onStart"></drop-down>
        </div>
        <div class="column is-6">
          <drop-down type="forFranchiseeSelection" @change="onStart"></drop-down>
        </div>
      </div>
      Total Records :
      <b>{{ total }}</b>
    </section>
    <section class="section is-main-section">
      <card-component title class="has-table has-mobile-sort-spaced">
        <b-table paginated :per-page="perPage" :striped="true" :hoverable="true" :data="concessionInfo" style="overflow-x:scroll">
          <template slot-scope="props">
            <b-table-column field="name" label="Concession Name" sortable> {{ props.row.name }} </b-table-column>
            <b-table-column field="concessionType" label="Concession Type" sortable>{{ props.row.concessionType }}</b-table-column>
            <b-table-column field="priority" label="Adjust Type" sortable>{{ props.row.adjustType }} </b-table-column>

            <b-table-column field="feeType.name " label="Fee Type" sortable>
              <b-tag type="is-info">{{ props.row.feeType.name }} </b-tag></b-table-column
            >
            <b-table-column field="franchisee.companyName" label="Franchisee" sortable>
              <b-tag type="is-info">{{ props.row.franchisee ? props.row.franchisee.companyName : 'NA' }} </b-tag></b-table-column
            >

            <b-table-column field="amountOrPercentage" label="Amount or %" sortable> {{ props.row.amountOrPercentage }}</b-table-column>

            <!-- <b-table-column field="adjustOrder" label="Adjust Order" sortable> {{ props.row.adjustOrder }}</b-table-column> -->

            <b-table-column :class="isActiveColor[props.row.isActive]" field="isActive" label="Status" sortable> {{ props.row.isActive ? 'Active' : 'Not Active' }}</b-table-column>

            <b-table-column label="Action">
              <a @click="getEditinfo(props.row.id)"> Adjust Settings</a>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nothing here.</p>
              </div>
            </section>
          </template>
        </b-table>
      </card-component>
    </section>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import Multiselect from 'vue-multiselect'
import server from '../../../store/server'
import dialogError from '@/components/dialogError.vue'
import store from '@/store'
import DropDown from '../../reusableComp/dropDown'
import constants from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'FeeConcessionList',
  components: {
    CardComponent,
    Multiselect,
    DropDown
  },
  data () {
    return {
      flag: '',
      franchiseeIDs: [],
      franchiseeArr: [],
      concessionInfo: [],
      total: 0,
      paginated: false,
      perPage: 10,
      isLoading: false,

      enableFilterModal: false,
      viewMoreData: [],
      modalOk: false,
      title: '',
      data: '',
      concessionType: [],
      concessionTypeVariable: '',
      concessionOrderTypeVariable: '',
      concessionOrderVariable: '',
      concessionOrderType: [],
      concessionOrder: [],
      concessionName: '',
      amount: '',
      feeType: [],
      feeTypeVariable: '',
      id: '',
      fromApiData: [],
      someParamsVisible: false,
      isActive: true,
      isApprovalNeeded: false,
      isActiveColor: {
        true: 'has-text-success',
        false: 'has-text-danger'
      },
      royaltyConcession: constants.CONCESSION_TYPE.royalty
    }
  },

  async created () {
    this.$store.dispatch('getCurrentAcadmicYearID')
    await this.onStart()
  },

  computed: {
    academicYearID: {
      get () {
        return store.state.feeComponent.academicYearID
      },
      set (value) {
        store.commit('updateAcadmicYrId', value)
      }
    },
    franchiseeID: {
      get () {
        return store.state.feeComponent.franchiseeID
      },
      set (value) {
        store.commit('updateFranchiseeID', value)
      }
    }
  },

  watch: {
    franchiseeID: function (values) {
      if (!values) {
        this.total = 0
        this.concessionInfo = []
      }
    },
    academicYearID: function (values) {
      if (!values) {
        this.values = values
        this.total = 0
        this.concessionInfo = []
      }
    }
  },
  updated () {},
  methods: {
    closing: function () {
      this.academicYearID = this.academicYearID
      this.modalOk = false
      this.onStart()
    },
    exceptEValidation: function (event) {
      if (event.target.value === '') {
        event.target.value = ''
        return event
      }
    },
    onTouch: function () {
      this.flag = false
      return true
    },
    allFranchisee: function () {
      let tempArray = []
      if (this.flag === true) {
        this.franchiseeArr.forEach(Obj => {
          tempArray.push(Obj)
        })
      }

      this.franchiseeIDs = tempArray
    },

    onStart: async function () {
      await this.getConcessionList()
      await this.getFranchiseeList()
      if (this.franchiseeID === '' || this.academicYearID === '') {
        return this.$buefy.toast.open({
          message: 'Please select below details',
          type: 'is-danger',
          duration: 4000
        })
      } else {
        if (this.academicYearID || this.franchiseeID) {
          let payload = {}
          if (this.academicYearID) {
            payload.academicYearID = this.academicYearID
          }
          if (this.franchiseeID) {
            payload.franchiseeID = this.franchiseeID
          }
          this.isLoading = true
          let result = await server.get('concessions', this, payload)
          this.isLoading = false
          if (_.isEqual(result.success, 200)) {
            this.fromApiData = result.data
          } else {
            this.isLoading = false
            return dialogError.ErrorMsg(result.message, 'is-danger', this)
          }
          this.concessionInfo = this.fromApiData || []
          if (!this.concessionInfo) {
            this.total = 0
          } else {
            this.total = this.concessionInfo.length
          }
        }
      }
    },
    getFranchiseeList: async function (id) {
      this.isLoading = true
      const data = await server.get('franchisee/active', this)
      this.isLoading = false
      if (_.isEqual(data.success, 200)) {
        this.franchiseeArr = data.data.rows
      } else {
        this.isLoading = false
        return dialogError.ErrorMsg(data.message, 'is-danger', this)
      }
    },
    getEditinfo: async function (id) {
      this.id = id
      this.modalOk = true
      this.someParamsVisible = true
      this.title = 'Adjust Concession Setting'
      this.isLoading = true
      const data = await server.get(`concessions/${id}`, this)
      this.isLoading = false
      if (_.isEqual(data.success, 200)) {
        this.amount = data.data.amountOrPercentage
        this.concessionName = data.data.name
        this.concessionTypeVariable = data.data.concessionType
        this.concessionOrderTypeVariable = data.data.adjustType
        this.concessionOrderVariable = data.data.adjustOrder
        this.feeTypeVariable = data.data.feeType.id
        this.franchiseeIDs = data.data.franchisee
        this.academicYearID = data.data.franchiseeAcademicYear.id
        this.isActive = data.data.isActive
        this.isApprovalNeeded = data.data.isApprovalNeeded
      } else {
        this.isLoading = false
        return dialogError.ErrorMsg(data.message, 'is-danger', this)
      }
    },
    async ModalOpen () {
      this.modalOk = true
      this.someParamsVisible = false
      this.title = 'Create Concession Settings'
      this.amount = ''
      this.concessionName = ''
      this.concessionTypeVariable = ''
      this.concessionOrderTypeVariable = ''
      this.concessionOrderVariable = ''
      this.feeTypeVariable = []

      this.franchiseeIDs = []
      this.isActive = true
      this.flag = false
      this.isApprovalNeeded = false
    },

    getConcessionList: async function () {
      this.modalOk = false
      this.isLoading = true
      const feeCesponse = await server.get('fee-concession-type', this)
      this.isLoading = false

      this.isLoading = true
      const data = await server.get('fee-type', this)
      this.isLoading = false
      if (_.isEqual(feeCesponse.success, 200) || _.isEqual(data.success, 200)) {
        this.concessionType = _.uniqBy(_.map(feeCesponse.data, 'type'))
        this.concessionOrderType = _.filter(_.uniqBy(_.map(feeCesponse.data, 'orderType')), orderType => !_.isEqual(orderType, null))
        this.concessionOrder = _.filter(_.uniqBy(_.map(feeCesponse.data, 'order')), order => !_.isEqual(order, null))
        this.feeType = data.data.rows
      } else {
        this.isLoading = false
        return dialogError.ErrorMsg(data.message, 'is-danger', this)
      }
    },
    saveSettings: async function () {
      const formdata = {
        name: this.concessionName,
        concessionOrderType: this.concessionOrderTypeVariable,
        concessionOrder: 'Descending',
        amount: this.amount,
        isActive: this.isActive,
        isApprovalNeeded: this.isApprovalNeeded
      }

      if (this.title === 'Adjust Concession Setting') {
        this.isLoading = true
        let updateRes = await server.put('concessions', this, this.id, formdata)
        this.isLoading = false
        if (_.isEqual(updateRes.success, 200)) {
          await this.onStart()
          this.amount = ''
          this.concessionName = ''
          this.concessionTypeVariable = ''
          this.concessionOrderTypeVariable = ''
          this.concessionOrderVariable = ''
          this.feeTypeVariable = []
          this.franchiseeIDs = []

          this.isActive = ''
          this.flag = false
          this.isApprovalNeeded = false
          this.isLoading = false
          return dialogError.ErrorMsg('Saved Successfully', 'is-info', this)
        } else {
          this.isLoading = false
          return dialogError.ErrorMsg(updateRes.message, 'is-danger', this)
        }
      } else {
        if (this.feeTypeVariable.length === 0) {
          return dialogError.ErrorMsg('Select Fee Type', 'is-danger', this)
        }
        if (this.franchiseeIDs.length === 0 && this.concessionTypeVariable !== 'Royalty Concession') {
          return dialogError.ErrorMsg('Select Franchisee Type', 'is-danger', this)
        } else {
          formdata.concessionType = this.concessionTypeVariable
          formdata.feeTypeID = this.feeTypeVariable || []
          formdata.franchiseeID = _.map(this.franchiseeIDs, 'id') || []

          formdata.academicYearID = this.academicYearID || ''
          this.isLoading = true
          let postRes = await server.post('concessions', this, formdata)
          this.isLoading = false
          if (_.isEqual(postRes.success, 200)) {
            await this.onStart()
            this.isLoading = false
            return dialogError.ErrorMsg('Saved Successfully', 'is-info', this)
          } else {
            this.isLoading = false
            return dialogError.ErrorMsg(postRes.message, 'is-danger', this)
          }
        }
      }
    }
  }
}
</script>
<style scoped>
.buttons {
  flex-wrap: nowrap;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
